import { useModal } from './useModal';
import { localStore } from '~/modules/common/utils/localStorageUtils';

export function useCookieConsent() {
  const { openModal } = useModal();
  /**
   * Show Modal
   */
  const showCookieModal = () => {
    openModal(import('~/modules/common/components/modals/ModalCookie' /* webpackChunkName: "ModalCookie" */));
  };

  return {
    setCookieConsent: () => {
      localStore.setItem('o-cookies-accepted', 1);
    },
    getCookieConsent: () => {
      return localStore.getItem('o-cookies-accepted');
    },
    showCookieModal,
  };
}
